import styles from './FExHeader.module.scss';
import { H, I18n } from '@dm/components';
import React from 'react';
export default function FExHeader(_ref) {
  var title = _ref.title,
    instructions = _ref.instructions,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(H, {
    className: styles.header
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: title
  })), instructions && /*#__PURE__*/React.createElement("span", {
    className: styles.instructions
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: instructions
  }))), children && /*#__PURE__*/React.createElement("div", null, children));
}